import { render } from "./KontrolGuru.vue?vue&type=template&id=830030c8"
import script from "./KontrolGuru.vue?vue&type=script&lang=js"
export * from "./KontrolGuru.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__